const url = 'providers';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const LOADER_PROVIDER = 'LOADER_PROVIDER';
const SET_DATA_PROVIDER = 'SET_DATA_PROVIDER';
const SET_PAGE_PROVIDER = 'SET_PAGE_PROVIDER';
const SET_UPDATE_DATA_PROVIDER = 'SET_UPDATE_DATA_PROVIDER';
const SET_BUSCADOR_PROVIDER = 'SET_BUSCADOR_PROVIDER';
const SET_FILTRO_PROVIDER = 'SET_FILTRO_PROVIDER';

const listar = (page = 1) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_PROVIDER, cargando: true});
    const store = getStore();
    const search = store.provider.buscador;
    const filtro = store.provider.filtro_provider;
    let params = {page, search};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_PROVIDER, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_PROVIDER, data});
            dispatch({type: SET_PAGE_PROVIDER, page});
        }
        dispatch({type: LOADER_PROVIDER, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_PROVIDER, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_PROVIDER, cargando: false});
        if(error.statusCode === 404){
            dispatch(push('/providers'))
        }
    }).then((data) => {
        dispatch({type: LOADER_PROVIDER, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_PROVIDER, updateData: data});
            dispatch(initializeForm('provider', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.provider.values;

    if(!formData.hasOwnProperty('retention')){
        formData.retention = false;
    }

    dispatch({type: LOADER_PROVIDER, cargando: true})

    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_PROVIDER, cargando: false})
        Swal('Éxito', 'Se ha creado el proveedor.', 'success')
        .then(() => {
            dispatch(push('/providers'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_ROL, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_PROVIDER, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.provider.values);
    dispatch({type: LOADER_PROVIDER, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_PROVIDER, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/providers'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_PROVIDER, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/providers/create'));
        }
    })
}

const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_PROVIDER, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_PROVIDER, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
            })
    }).then((data) => {
        dispatch({type: LOADER_PROVIDER, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_PROVIDER, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_PROVIDER, filtro_rol: filtro});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
};

export const reducer = {
    [LOADER_PROVIDER]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_PROVIDER]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_PROVIDER]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_PROVIDER]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_PROVIDER]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_PROVIDER]: (state, { filtro_provider }) => {
        return {...state, filtro_provider }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_provider: null,
    updateData: {},
};

export default handleActions(reducer, initialState)
